import React from "react";

function UsersReviews({ containerStyling, customStyling, reviewsData }) {
  return (
    <div className={`${containerStyling ? containerStyling : ""}`}>
      <ul
        className={`${
          customStyling
            ? customStyling
            : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-5 lg:gap-y-8 max-w-lg md:max-w-4xl mx-auto justify-items-center"
        } `}
      >
        {reviewsData &&
          reviewsData.map(({ link, src, alt }, i) => {
            return (
              <li key={i}>
                <a href={link}>
                  <img src={src} alt={alt} className="w-52 h-auto" />
                </a>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

export default UsersReviews;
